<script setup>
  import { Modal, Popover } from "bootstrap";
  import { defineAsyncComponent, onMounted, onBeforeUnmount, inject, shallowRef, ref } from "vue";
  const ModalPackageProcess = defineAsyncComponent(() => import("../../components/modals/pkgProcess.vue"));

  const axios = inject('axios');
  let toProcess = shallowRef(0);
  let pop = shallowRef({})
  const checkBtn = ref(null);
  const anchorBtn = ref(null);
  let mkVisible = shallowRef(false);
  let modal = shallowRef({});
  let popoverShownHandler = null;
  let popoverHiddenHandler = null;

  onMounted(() => {
    if (!checkBtn.value) {
      return;
    }
    popoverShownHandler = () => updateAnchorOffset();
    popoverHiddenHandler = () => resetAnchorOffset();
    checkBtn.value.addEventListener('shown.bs.popover', popoverShownHandler);
    checkBtn.value.addEventListener('hidden.bs.popover', popoverHiddenHandler);
    getStats()
  })

  onBeforeUnmount(() => {
    if (checkBtn.value && popoverShownHandler) {
      checkBtn.value.removeEventListener('shown.bs.popover', popoverShownHandler);
      checkBtn.value.removeEventListener('hidden.bs.popover', popoverHiddenHandler);
    }
    pop?.dispose?.();
  })

  function updateAnchorOffset() {
    if (!anchorBtn.value || !pop) {
      return;
    }
    const applyOffset = () => {
      const describedBy = checkBtn.value?.getAttribute('aria-describedby');
      const tip = pop.getTipElement?.() || (describedBy ? document.getElementById(describedBy) : null);
      const tipWidth = tip?.getBoundingClientRect().width || 0;
      if (!tipWidth) {
        return false;
      }
      const gap = 8;
      anchorBtn.value.style.transform = `translateX(-${tipWidth + gap}px)`;
      return true;
    };
    requestAnimationFrame(() => {
      if (!applyOffset()) {
        setTimeout(applyOffset, 0);
      }
    });
  }

  function resetAnchorOffset() {
    if (anchorBtn.value) {
      anchorBtn.value.style.transform = 'translateX(0)';
    }
  }

  async function getStats() {
    let { data } = await axios.get('/manager/get-stats')
    toProcess = data.stats

    if (toProcess > 0) {
      pop = new Popover(checkBtn.value, {
        delay: 3000,
        html: true,
        content: `<div class="text-start">There ${toProcess > 1 ? 'are' : 'is'} <strong>${toProcess}</strong> package${toProcess > 1 ? 's' : ''} to process.</div>`,
        placement: 'left',
        trigger: 'manual'
      });

      pop.show()
    }
  }

  function fireProcessModal() {
    mkVisible.value = true;
    modal = new Modal(document.getElementById('package_process'), { keyboard: false, backdrop: 'static', focus: true })
    modal.show();
  }
</script>

<template>
  <ModalPackageProcess :visible="mkVisible" :modal="modal" />
  <div class="floating-actions">
<!--    <a class="btn-scroll-top bg-warning show" id="floatingNotificationAnchor" v-popover="'Package Checkoff'" ref="anchorBtn" style="z-index: 99999; cursor: pointer;" @click.once="fireCheckOffModal">-->
<!--      <i class="btn-scroll-top-icon mdi mdi-airplane"></i>-->
<!--    </a>-->
    <a class="btn-scroll-top show" id="floatingNotificationCheck" ref="checkBtn" style="z-index: 99999; cursor: pointer;" @click.once="fireProcessModal">
      <i class="btn-scroll-top-icon mdi mdi-check"></i>
    </a>
  </div>
</template>
<style scoped>
  .floating-actions {
    position: fixed;
    right: 1.25rem;
    bottom: 1.25rem;
    display: flex;
    align-items: center;
    gap: 8px;
    z-index: 99999;
  }

  .floating-actions .btn-scroll-top {
    position: static;
  }
</style>
